import { render, staticRenderFns } from "./passwordLogin.vue?vue&type=template&id=032f68c7&scoped=true&"
import script from "./passwordLogin.vue?vue&type=script&lang=js&"
export * from "./passwordLogin.vue?vue&type=script&lang=js&"
import style0 from "./passwordLogin.vue?vue&type=style&index=0&id=032f68c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032f68c7",
  null
  
)

export default component.exports